module.exports = __webpack_public_path__ + "assets/f85983489d5dffa7b1d0507b88cc676c.mp3";